/**
 * Channel error state: not in a valid Teams channel.
 */
import React from "react";
import { Stack, Label, DefaultButton, Icon } from "@fluentui/react";
import { useTheme } from "../../../theme/OAS365Theme";
import { USER_DATA_LOAD_STATUS } from "../../../redux/constants/metaData";
import channelErrorImage from "../../../assets/channelErrorImage.svg";

export default function ChannelErrorView({ onRetry }) {
  const theme = useTheme();

  return (
    <div style={{ height: "100vh", width: "100vw", overflow: "hidden" }}>
      <Stack
        verticalAlign="center"
        horizontalAlign="center"
        styles={{ root: { height: "100vh", backgroundColor: theme.colors.backgroundColor } }}
        tokens={{ childrenGap: 20 }}
      >
        <Stack.Item>
          <Label
            style={{
              fontFamily: theme.fonts.regular,
              color: theme.colors.fontColor,
              fontSize: "18px",
              fontWeight: theme.fontWeight.titleWeight,
              textAlign: "center",
            }}
          >
            Please go to a Teams channel to use Addovation Share
          </Label>
        </Stack.Item>
        <Stack.Item>
          <img
            src={channelErrorImage}
            style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
            alt="Channel Error"
          />
        </Stack.Item>
        <Stack.Item>
          <DefaultButton
            onClick={() => onRetry?.(USER_DATA_LOAD_STATUS.onStart)}
            styles={{
              root: {
                borderRadius: 8,
                border: `1px solid ${theme.colors.themeDarkColor}`,
              },
              label: {
                color: theme.colors.themeDarkColor,
                fontWeight: 600,
                fontFamily: theme.fonts.regular,
              },
            }}
            onRenderText={() => (
              <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                Login / Retry
                <Icon iconName="SignIn" styles={{ root: { color: theme.colors.themeDarkColor } }} />
              </span>
            )}
          />
        </Stack.Item>
      </Stack>
    </div>
  );
}
